import { LoggingService, LookupService } from 'src/services';
import { CompanyTypeDTO, SettingDTO } from 'src/services/generated/api.generated.v1';
import { Mapper } from 'src/utils';
import { ActionTree, Commit } from 'vuex';
import { StateInterface } from '../index';
import { SettingStateInterface } from './state';


const actions: ActionTree<SettingStateInterface, StateInterface> = {
  clearSettings({ commit }: { commit: Commit }) {
    commit('updateSettingState', null);
  },
  setSettings({ commit, state }: { commit: Commit, state: SettingStateInterface }): Promise<void> {
    const lookupService = new LookupService();

    return new Promise((resolve, reject) => {
      if (state.initialized) {
        resolve();
      } else {
        lookupService.Settings()
          .then((dto: SettingDTO) => {
            commit('updateSettingState', dto);
            return lookupService.CompanyType()
          })
          .then((dto: CompanyTypeDTO) => {
            commit('updateSettingConsumerSupportState', dto);
            resolve();
          })
          .catch(err => {
            LoggingService.LogError(err);
            reject();
          });
      }
    });
  },
  setCompany({ commit }: { commit: Commit }, company : string) {
    commit('setCompany', company);
    commit('setCompanyDisplayName', Mapper.MapCompanyDisplayName(company));
  }
};

export default actions;
